<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" id="reasonCodesContainer" fxLayout="column" fxLayoutGap="10px">
  <h2 class="page-header left" fxFlex="100%" fxLayout="row">Mantenimiento de Motivos Despacho</h2>
  <div class="right" fxFlex="100%" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-md="column" *ngIf="canCreateUpdateUser">
    <button mat-icon-button color="primary" (click)="addRow()" >
      <mat-icon title='Agregar fila'>add_circle</mat-icon>
    </button>
    <button mat-icon-button color="primary" class="button1" (click)="saveRows()" [disabled]="disableSaveButton">
      <mat-icon title='Salvar'>save</mat-icon>
    </button>
  </div>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div #tableContainer class="table-height">
    <table mat-table matSort [dataSource]="dataSource">
      <!-- Código de motivo Column -->
      <ng-container matColumnDef="codMotivo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Cód Razón
          <rem-string-filter #tableFilter columnDef="codMotivo" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td class="cell-width-smtext" mat-cell *matCellDef="let element" >
          <span >{{element.codMotivo}}</span>

        </td>
      </ng-container>
      <!-- Descripcion Column -->
      <ng-container matColumnDef="descMotivo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Descripción Código
          <rem-string-filter #tableFilter columnDef="descMotivo" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td class="cell-width-description" mat-cell *matCellDef="let element" [style]="{'text-align':'left'}">
          <span *ngIf="!element.add">{{element.descMotivo}}</span>
            <mat-form-field class="cell-width-description" appearance="fill" *ngIf="element.add">
              <input matInput [(ngModel)]="element.descMotivo" required maxlength="50" (change)="checkRows(element)" autocomplete="off"/>
              <mat-icon matPrefix *ngIf="element.descMotivo !== element.originalMotivo.descMotivo && !element.add"
                        color="warn" class="dirty-indicator">info</mat-icon>
            </mat-form-field>
        </td>
      </ng-container>
      <!-- Fecha de Creacion Column -->
      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fecha<br>Creación
          <rem-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td class="cell-width-smtext" mat-cell *matCellDef="let element">{{element.fecCreacion | customDate}}</td>
      </ng-container>
      <!-- Usu de Creacion Column -->
      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Usu<br>Creación
          <rem-string-filter #tableFilter columnDef="usrCreacion" [operators]="operators"
                             (filterChange)="filterChange($event);"></rem-string-filter></th>
        <td class="cell-width-smtext" mat-cell *matCellDef="let element">{{element.usrCreacion}}</td>
      </ng-container>
      <!-- Fecha de Modificacion Column -->
      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fecha<br>Modificación
          <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td class="cell-width-smtext" mat-cell *matCellDef="let element">{{element.fecModif | customDate}}</td>
      </ng-container>
      <!-- Usu de Modificacion Column -->
      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Usu<br>Modificación
          <rem-string-filter #tableFilter columnDef="usrModif" [operators]="operators"
                             (filterChange)="filterChange($event);"></rem-string-filter></th>
        <td class="cell-width-smtext" mat-cell *matCellDef="let element">{{element.usrModif}}</td>
      </ng-container>
      <!-- Estado Column -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col"> Estado </th>
        <td class="cell-width-lgtext" mat-cell *matCellDef="let element" [style]="{'text-align':'center'}">

          <div *ngIf="!element.editing || element.add; else estadoBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #estadoBox>
            <mat-form-field class="cell-width-lgtext" appearance="fill" (change)="checkRows(element)">
              <mat-select [(ngModel)]="element.estado" name="estado" required>
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="element.estado !== element.originalMotivo.estado && !element.add"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- Edit Button Column -->
      <ng-container matColumnDef="edited">
        <th mat-header-cell *matHeaderCellDef scope="col" [hidden]="!canCreateUpdateUser"></th>
        <td mat-cell *matCellDef="let element" [hidden]="!canCreateUpdateUser">
          <button mat-icon-button *ngIf="!element.editing && canCreateUpdateUser" (click)="editRow(element)">
            <mat-icon title='Modificar' color="secondary">create</mat-icon>
          </button>
          <button mat-icon-button *ngIf="element.editing && canCreateUpdateUser" (click)="cancelRow(element)">
            <mat-icon title='Cancelar' color="tertiary">cancel</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
  </div>
  <mat-paginator #paginator [length]="resultsLength" [pageSize]="defaultPageSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
</div>
